import { Pill } from '@user-interviews/ui-design-system';

import { registerComponent } from 'lib/react_on_rails';

export default Pill;

registerComponent('Pill', Pill);
